import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';
import Icon from '@ant-design/icons';
import { ReactComponent as UnlimitedIcon } from '../assets/unlimited.svg';

const EnterpriseUnlimitedTag = () => {
  const { t } = useTranslate();

  return (
    <EnterpriseUnlimited>
      <Icon component={UnlimitedIcon} />
      {t('market.无限')}
    </EnterpriseUnlimited>
  );
};

export default EnterpriseUnlimitedTag;

const EnterpriseUnlimited = styled.span`
  height: 18px;
  padding: 2px 4px;
  font-weight: 400;
  font-size: 12px;
  color: var(--fett-scenario-success-text);
  line-height: 18px;
  background: var(--fett-surface-success-bg);
  border-radius: 4px;
`;
